import React, { useEffect } from "react";
import ContactForm from "./ContactForm";

export default function ContactUsPage() {
  useEffect(() => {
    document.title = "Contact | Rising Sun Globalized Firm";
    return () => { document.title = "Rising Sun Globalized Firm | Global IT & AI Solutions"; };
  }, []);
  return (
    <div className="contact-us-page">
      <ContactForm title="Contact" />
    </div>
  );
}
